import styled from 'styled-components';
import { Image as AntImage } from 'antd';

export const Image = styled(AntImage)`
    max-width: 350px;
`;
